<div class="d-inline-flex">
  <ncp-button
    #addTreatmentButton
    [options]="btnTOptions()"
  >
    <img
      [ngSrc]="assets.healthIcons.svg.outline.devices.hospitalized.src"
      width="18"
      height="18"
      alt="Add Treatment"
      class="healthIcon"
    />
  </ncp-button>

  <ncp-modal
    #mod
    [options]="modOptions()"
  >
    <form
      id="treatment_form"
      name="treatment_form"
      [formGroup]="form"
      #tFrm="ngForm"
      class="d-flex flex-column gap-3"
      (ngSubmit)="onFormSubmit()"
    >
      <ncp-text-area #treatmentTxt [(options)]="recommendationsOptions" />
    </form>
  </ncp-modal>
</div>
